// Per-environment settings injected at runtime (/config.json served by nginx with no-cache), so
// the same image runs in every environment. Only public values: no secrets in the frontend.
export async function loadRuntimeConfig<T extends object>(requiredKeys: ReadonlyArray<keyof T & string>): Promise<T> {
  const response = await fetch(`${import.meta.env.BASE_URL}config.json`, { cache: 'no-store' })
  if (!response.ok) {
    throw new Error(`config.json returned ${response.status}`)
  }

  const config = (await response.json()) as Partial<T>
  for (const key of requiredKeys) {
    if (!config[key]) {
      throw new Error(`config.json is missing "${key}"`)
    }
  }

  return config as T
}
